/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    category: PropTypes.bool,
    center: PropTypes.bool,
    right: PropTypes.bool,
    minSize: PropTypes.bool,
    action: PropTypes.bool,
    cliquable: PropTypes.bool,
    checkbox: PropTypes.bool,
    sortable: PropTypes.bool,
    empty: PropTypes.bool,
    img: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'td',
    center: false,
    right: false,
    minSize: false,
    action: false,
    cliquable: false,
    checkbox: false,
    sortable: false,
    empty: false,
    img: false,
};

const TableCell = (props) => {
    const classNames = [
        'c-table__cell',
        props.center ? 'c-table__cell--center' : '',
        props.right ? 'c-table__cell--right' : '',
        props.minSize ? 'c-table__cell--min-size' : '',
        props.action ? 'c-table__cell--action' : '',
        props.cliquable ? 'c-table__cell--cliquable' : '',
        props.checkbox ? 'c-table__cell--checkbox' : '',
        props.sortable ? 'c-table__cell--sortable' : '',
        props.empty ? 'c-table__cell--empty' : '',
        props.img ? 'c-table__cell--img' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

TableCell.propTypes = propTypes;

TableCell.defaultProps = defaultProps;

export default TableCell;
